import { render } from "./StockSearchFormPage.vue?vue&type=template&id=63f4728f&scoped=true"
import script from "./StockSearchFormPage.vue?vue&type=script&lang=js"
export * from "./StockSearchFormPage.vue?vue&type=script&lang=js"

import "./StockSearchFormPage.vue?vue&type=style&index=0&id=63f4728f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f4728f"]])

export default __exports__